import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'

import AssignedItemsButton from 'components/AssignedItemsButton'

const Menus = ({ id, setFormStep, showValidationErrors }) => {
  const { values, errors } = useFormikContext()

  const isError = !isEmpty(errors?.menuUuids) && showValidationErrors

  const handleClick = () => {
    setFormStep('menusDrawer')
  }

  return (
    <div className="content-wrapper -flags-wrapper -block" id={id}>
      <h3 className="header-title">Menus</h3>
      <div
        className="text-field padding-top-sm"
        data-cy="selected-menus-button"
      >
        <AssignedItemsButton
          handleClick={handleClick}
          label="Select Menus"
          error={isError}
          assignedItems={values?.menuUuids.length}
        />
      </div>
    </div>
  )
}

export default Menus
